import React, { Component } from 'react';
import {NavLink} from 'react-router-dom';


class details extends Component {
  render() {
    return (
      <div>
          <p>TO DO</p>
      </div>
    );
  }
}

export default details;
